import { render, staticRenderFns } from "./prd_stkinit.vue?vue&type=template&id=a9ec3a50&scoped=true&"
import script from "./prd_stkinit.vue?vue&type=script&lang=js&"
export * from "./prd_stkinit.vue?vue&type=script&lang=js&"
import style0 from "./prd_stkinit.vue?vue&type=style&index=0&id=a9ec3a50&scoped=true&lang=less&"
import style1 from "./prd_stkinit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ec3a50",
  null
  
)

export default component.exports